import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/views/jqueryView';
import * as summernoteClient from '../../../../../common/models/summernotes/summernoteClient';
import { handleHttpError } from '../../../../../common/http/errorHandler';
import { simpleFlashMessage } from '../../../../../common/utils/flashMessage';

export default class EditorView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.setUpBody();
  }

  setUpBody() {
    const body = $('#company_ir_body').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video']],
        ['view', ['fullscreen', 'help']],
      ],
      callbacks: {
        onImageUpload: files => {
          summernoteClient
            .create(files[0])
            .then(uploaded => {
              body.summernote('insertImage', uploaded.url);
            })
            .catch((error: unknown) => {
              handleHttpError(error, simpleFlashMessage);
            });
        },
      },
    });
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: JQuery.ClickEvent) {
    const link = $(event.currentTarget);
    link.prev('input[type=hidden]').val('1');
    link.closest('fieldset').hide();
    event.preventDefault();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: JQuery.ClickEvent) {
    const link = $(event.currentTarget);
    const time = new Date().getTime();
    const regexp = new RegExp(link.data('id'), 'g');
    link.before(link.data('fields').replace(regexp, time));
    event.preventDefault();
  }
}
